<template>
  <div v-loading="loading">
    <img
      src="https://web-demo.tsingke.com.cn/static/img/logo.3d18d8d.png"
      width="8%"
    />
    <img src="@/assets/images/email_link_head.png" width="100%" />
    <div class="contain-email-link">
      <h2 style="text-align:center;padding-bottom:20px;">
        样品鉴定失败原因分析
      </h2>
      <p style="padding-bottom: 10px">
        以下是针对每个样品的具体的失败原因分析及建议的解决方案。请根据实际情况，考虑并选择最合适的处理路径。
      </p>
      <el-table :data="reasonForFailure[pageType]" border style="width: 100%">
        <el-table-column prop="failType" label="失败类型" width="200">
        </el-table-column>
        <el-table-column prop="demoName" label="涉及样品名称" width="180">
        </el-table-column>
        <el-table-column prop="causeAnalysis" label="原因分析" width="240">
        </el-table-column>
        <el-table-column prop="solution" label="解决方案">
          <template slot-scope="scope">
            <div v-html="scope.row.solution" @click="handlerJump"></div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import {
  keyJsonStoresHashKey,
  customerClcikEvent,
  checkJsonStoresHashKey
} from "@/services/api.index";
export default {
  data() {
    return {
      loading: false,
      causeAnalysiss: [
        "可能是 模板DNA浓度低或引物不佳",
        "可能是 模板DNA浓度低或有杂质"
      ],
      tableData: [],
      linkList: {
        hsdyqjtUrl: "",
        tqUrl: "",
        jpmixUrl: "",
        xjjyztqsjhUrl: "",
        x2TskmmUrl: "",
        jmzksjhUrl: "",
        zwdnatqsjhUrl: "",
        dwdnatqsjhUrl: "",
        sjywUrl: "",
        pcrywsjjntskUrl: ""
      },
      reasonForFailure: {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: [],
        8: [],
        9: [],
        10: []
      },
      pageType: "",
      solution1: "",
      solutionStripless3: "",
      solutionLowConcentration3: "",
      solutionStripless6: "",
      solutionLowConcentration6: "",
      solutionStripless10: "",
      solutionLowConcentration10: "",
      linewConcentration10: ""
    };
  },
  async created() {
    const { info } = this.$route.query;
    this.getData();
  },
  methods: {
    handlerJump() {
      const linkType = event.target.dataset.type.split("=")[1];
      customerClcikEvent(linkType);
    },
    async getData() {
      const { info } = this.$route.query;
      this.loading = true;
      const { data } = await keyJsonStoresHashKey(info);
      this.loading = false;
      this.pageType = data.pageType;
      Object.keys(data).forEach(key => {
        if (key.includes("Url")) {
          this.linkList[key] = data[key];
        }
      });
      this.handlerSolution();
      this.reasonForFailure[this.pageType] = data.detailList;
      this.reasonForFailure[this.pageType].forEach((v, i) => {
        v = {
          ...v,
          ...data.detailList[i]
        };
        if (this.pageType === 3) {
          if (v.failType === "无条带/无主带") {
            v.solution = this.solutionStripless3;
            v.causeAnalysis = this.causeAnalysiss[0];
          } else {
            v.solution = this.solutionLowConcentration3;
            v.causeAnalysis = this.causeAnalysiss[1];
          }
        } else if (this.pageType === 6) {
          if (v.failType === "无条带/无主带") {
            v.solution = this.solutionStripless6;
            v.causeAnalysis = this.causeAnalysiss[0];
          } else {
            v.solution = this.solutionLowConcentration6;
            v.causeAnalysis = this.causeAnalysiss[1];
          }
        } else if (this.pageType === 10) {
          v.causeAnalysis = this.causeAnalysiss[1];
          if (i == 0) {
            if (v.manyPrimerFlag) {
              v.solution = this.solutionLowConcentration10;
            } else {
              v.solution = this.solutionStripless10;
            }
          } else if (i == 1) {
            v.solution = this.linewConcentration10;
          }
        } else {
          v.solution = this["solution" + this.pageType];
          if (
            this.pageType === 1 ||
            this.pageType === 4 ||
            this.pageType === 6
          ) {
            v.causeAnalysis = this.causeAnalysiss[0];
          } else {
            v.causeAnalysis = this.causeAnalysiss[1];
          }
        }
        this.$set(this.reasonForFailure[this.pageType], i, v);
      });
    },
    handlerSolution() {
      this.solution1 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为无条带或无主带。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或引物不佳，建议您先对模板DNA进行质量检测，推荐您使用
            <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">“核酸电泳全家桶”</a>
          进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。</p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。根据您提供的引物序列判断您的实验样品为细菌，推荐您使用提取质量较好的试剂盒来制备高质量模板，如达领生物的
            <a href=${this.linkList["xjjyztqsjhUrl"]}  target='_Blank' data-type="${this.linkList["xjjyztqsjhUrl"]}">细菌基因组提取试剂盒</a>
          （货号：TSP701）；为了节省提取时间，我们推荐您可以使用直扩类产品,如擎科生物的
            <a href=${this.linkList["jmzksjhUrl"]}  target='_Blank' data-type="${this.linkList["jmzksjhUrl"]}">酵母直扩试剂盒</a>
          （货号:TSE0302)</p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，建议您优化PCR扩增程序或重新合成引物再次进行扩增。</p>
        </div>`;
      this.solution2 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为样品浓度低。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或有杂质，建议您先对模板DNA进行质量检测，推荐您使用“
            <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">核酸电泳全家桶</a>
          ”进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。</p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。根据您提供的引物序列判断您的实验样品为细菌，推荐您使用提取质量较好的试剂盒来制备高质量模板，如达领生物的
            <a href=${this.linkList["xjjyztqsjhUrl"]}  target='_Blank' data-type="${this.linkList["xjjyztqsjhUrl"]}">细菌基因组提取试剂盒</a>
          （货号：TSP701）；为了节省提取时间，我们推荐您可以使用直扩类产品,如擎科生物的
            <a href=${this.linkList["jmzksjhUrl"]}  target='_Blank' data-type="${this.linkList["jmzksjhUrl"]}">酵母直扩试剂盒</a>
          （货号:TSE0302)  </p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，可能是您当前使用的PCR酶扩增效率偏低。由于PCR酶对于DNA具有一定的偏好性，可通过优化PCR程序如：增加循环数、降低退火温度、适当提高Mg2+工作浓度来提高扩增效率，然而当您使的酶经过优化难以获得理想扩增时，推荐您使用扩增产量更高的PCR酶：如擎科生物 
            <a href=${this.linkList["x2TskmmUrl"]}  target='_Blank' data-type="${this.linkList["x2TskmmUrl"]}">2×TSINGKE Master Mix</a>
          （货号：TSE003）</p>
        </div>`;
      this.solutionStripless3 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为无条带或无主带。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或引物不佳，建议您先对模板DNA进行质量检测，推荐您使用
            <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">“核酸电泳全家桶”</a>
            进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。
          </p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。根据您提供的引物序列判断您的实验样品为细菌，推荐您使用提取质量较好的试剂盒来制备高质量模板，如达领生物的
            <a href=${this.linkList["xjjyztqsjhUrl"]}  target='_Blank' data-type="${this.linkList["xjjyztqsjhUrl"]}">细菌基因组提取试剂盒</a>
            （货号：TSP701），；为了节省提取时间，我们推荐您可以使用直扩类产品,如擎科生物的
            <a href=${this.linkList["jmzksjhUrl"]}  target='_Blank' data-type="${this.linkList["jmzksjhUrl"]}">酵母直扩试剂盒</a>
            （货号:TSE0302)
          </p>
          </p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，建议您优化PCR扩增程序或重新合成引物再次进行扩增。</p>
        </div>`;
      this.solutionLowConcentration3 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为样品浓度低。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或有杂质，建议您先对模板DNA进行质量检测，推荐您使用
            <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">“核酸电泳全家桶”</a>
            进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。</p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。根据您提供的引物序列判断您的实验样品为细菌，推荐您使用提取质量较好的试剂盒来制备高质量模板，如达领生物的
            <a href=${this.linkList["xjjyztqsjhUrl"]}  target='_Blank' data-type="${this.linkList["xjjyztqsjhUrl"]}">细菌基因组提取试剂盒</a>
            （货号：TSP701），；为了节省提取时间，我们推荐您可以使用直扩类产品,如擎科生物的
            <a href=${this.linkList["jmzksjhUrl"]}  target='_Blank' data-type="${this.linkList["jmzksjhUrl"]}">酵母直扩试剂盒</a>
            （货号:TSE0302)
          </p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，可能是您当前使用的PCR酶扩增效率偏低。由于PCR酶对于DNA具有一定的偏好性，可通过优化PCR程序如：增加循环数、降低退火温度、适当提高Mg2+工作浓度来提高扩增效率，然而当您使的酶经过优化难以获得理想扩增时，推荐您使用扩增产量更高的PCR酶：如擎科生物
            <a href=${this.linkList["x2TskmmUrl"]}  target='_Blank' data-type="${this.linkList["x2TskmmUrl"]}">2×TSINGKE Master Mix</a>
            （货号：TSE003）
          </p>
        </div>`;
      this.solution4 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为无条带或无主带。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或引物不佳，建议您先对模板DNA进行质量检测，推荐您使用“
            <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">核酸电泳全家桶</a>
          ”进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。</p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。根据您提供的引物序列判断您的实验样品为真菌，推荐您根据样品类型，选择提取质量较好的试剂盒来制备高质量模板，如
            <a href=${this.linkList["zwdnatqsjhUrl"]}  target='_Blank' data-type="${this.linkList["zwdnatqsjhUrl"]}">植物DNA提取试剂盒</a>
          （货号：TSP102）或
            <a href=${this.linkList["dwdnatqsjhUrl"]}  target='_Blank' data-type="${this.linkList["dwdnatqsjhUrl"]}">动物DNA提取试剂盒</a>
          （货号：TSP202）；为了节省提取时间，我们推荐您可以使用直扩类产品,如擎科生物
            <a href=${this.linkList["jmzksjhUrl"]}  target='_Blank' data-type="${this.linkList["jmzksjhUrl"]}">酵母直扩试剂盒</a>
          （货号:TSE0302)</p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，建议您优化PCR扩增程序或重新合成引物再次进行扩增。</p>
        </div>`;
      this.solution5 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为样品浓度低。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或有杂质，建议您先对模板DNA进行质量检测，推荐您使用“
            <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">核酸电泳全家桶</a>
          ”进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。</p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。根据您提供的引物序列判断您的实验样品为真菌，推荐您根据样品类型，选择提取质量较好的试剂盒来制备高质量模板，如
            <a href=${this.linkList["zwdnatqsjhUrl"]}  target='_Blank' data-type="${this.linkList["zwdnatqsjhUrl"]}">植物DNA提取试剂盒</a>
          （货号：TSP102）或
            <a href=${this.linkList["dwdnatqsjhUrl"]}  target='_Blank' data-type="${this.linkList["dwdnatqsjhUrl"]}">动物DNA提取试剂盒</a>
          （货号：TSP202）；为了节省提取时间，我们推荐您可以使用直扩类产品,如擎科生物
            <a href=${this.linkList["jmzksjhUrl"]}  target='_Blank' data-type="${this.linkList["jmzksjhUrl"]}">酵母直扩试剂盒</a>
          （货号:TSE0302)</p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，可能是您当前使用的PCR酶扩增效率偏低。由于PCR酶对于DNA具有一定的偏好性，可通过优化PCR程序如：增加循环数、降低退火温度、适当提高Mg2+工作浓度来提高扩增效率，然而当您使的酶经过优化难以获得理想扩增时，推荐您使用扩增产量更高的PCR酶：如擎科生物 
            <a href=${this.linkList["x2TskmmUrl"]}  target='_Blank' data-type="${this.linkList["x2TskmmUrl"]}">2×TSINGKE Master Mix</a>
          （货号：TSE003）</p>
        </div>`;
      this.solutionStripless6 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为无条带或无主带。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或引物不佳，建议您先对模板DNA进行质量检测，推荐您使用
            <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">“核酸电泳全家桶”</a>
            进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。
          </p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。根据您提供的引物序列判断您的实验样品为真菌，推荐您根据样品类型，选择提取质量较好的试剂盒来制备高质量模板，如
            <a href=${this.linkList["zwdnatqsjhUrl"]}  target='_Blank' data-type="${this.linkList["zwdnatqsjhUrl"]}">植物DNA提取试剂盒</a>
            （货号：TSP102）或
            <a href=${this.linkList["dwdnatqsjhUrl"]}  target='_Blank' data-type="${this.linkList["dwdnatqsjhUrl"]}">动物DNA提取试剂盒</a>
            （货号：TSP202）；为了节省提取时间，我们推荐您可以使用直扩类产品,如擎科生物
            <a href=${this.linkList["jmzksjhUrl"]}  target='_Blank' data-type="${this.linkList["jmzksjhUrl"]}">酵母直扩试剂盒</a>
            （货号:TSE0302)
          </p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，建议您优化PCR扩增程序或重新合成引物再次进行扩增。</p>
        </div>`;
      this.solutionLowConcentration6 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为样品浓度低。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或有杂质，建议您先对模板DNA进行质量检测，推荐您使用
            <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">“核酸电泳全家桶”</a>
            进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。</p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。根据您提供的引物序列判断您的实验样品为真菌，推荐您根据样品类型，选择提取质量较好的试剂盒来制备高质量模板，如
            <a href=${this.linkList["zwdnatqsjhUrl"]}  target='_Blank' data-type="${this.linkList["zwdnatqsjhUrl"]}">植物DNA提取试剂盒</a>
            （货号：TSP102）或
            <a href=${this.linkList["dwdnatqsjhUrl"]}  target='_Blank' data-type="${this.linkList["dwdnatqsjhUrl"]}">动物DNA提取试剂盒</a>
            （货号：TSP202）；为了节省提取时间，我们推荐您可以使用直扩类产品,如擎科生物
            <a href=${this.linkList["jmzksjhUrl"]}  target='_Blank' data-type="${this.linkList["jmzksjhUrl"]}">酵母直扩试剂盒</a>
            （货号:TSE0302)
          </p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，可能是您当前使用的PCR酶扩增效率偏低。由于PCR酶对于DNA具有一定的偏好性，可通过优化PCR程序如：增加循环数、降低退火温度、适当提高Mg2+工作浓度来提高扩增效率，然而当您使的酶经过优化难以获得理想扩增时，推荐您使用扩增产量更高的PCR酶：如擎科生物
            <a href=${this.linkList["x2TskmmUrl"]}  target='_Blank' data-type="${this.linkList["x2TskmmUrl"]}">2×TSINGKE Master Mix</a>
            （货号：TSE003）
          </p>
        </div>`;
      this.solution7 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为无条带、无主带或引物二聚体。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或有杂质，建议您先对模板DNA进行质量检测，推荐您使用“
            <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">核酸电泳全家桶</a>
          ”进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。 </p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。达领生物有适用于不同研究物种的高质量提取试剂盒，您可以根据自己的研究对象来进行选择【
            <a href=${this.linkList["tqUrl"]}  target='_Blank' data-type="${this.linkList["tqUrl"]}">提取</a>
          】</p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，可能是您当前使用的引物不合适，建议重新设计引物，请点击
            <a href=${this.linkList["sjywUrl"]}  target='_Blank' data-type="${this.linkList["sjywUrl"]}">设计引物</a>
          进行设计，您也可以参加
            <a href=${this.linkList["pcrywsjjntskUrl"]}  target='_Blank' data-type="${this.linkList["pcrywsjjntskUrl"]}">PCR引物设计技能提升课</a>
          ，学习引物设计原理与方法，自行设计并合成引物。</p>
        </div>`;
      this.solution8 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为无条带、无主带或引物二聚体。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或有杂质，建议您先对模板DNA进行质量检测，推荐您使用“
            <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">核酸电泳全家桶</a>
          ”进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。</p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。达领生物有适用于不同研究物种的高质量提取试剂盒，您可以根据自己的研究对象来进行选择【
            <a href=${this.linkList["tqUrl"]}  target='_Blank' data-type="${this.linkList["tqUrl"]}">提取</a>
          】</p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，可能是您当前使用的PCR酶扩增效率偏低。由于PCR酶对于DNA具有一定的偏好性，可通过优化PCR程序如：增加循环数、降低退火温度、适当提高Mg2+工作浓度来提高扩增效率，然而当您使的酶经过优化难以获得理想扩增时，推荐您使用耐脏性好，扩增效率高的PCR酶，如擎科生物的
            <a href=${this.linkList["jpmixUrl"]}  target='_Blank' data-type="${this.linkList["jpmixUrl"]}">金牌 Mix (green)</a>
          （货号：TSE101）</p>
        </div>`;
      this.solution9 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为浓度低。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或有杂质，建议您先对模板DNA进行质量检测，推荐您使用“
            <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">核酸电泳全家桶</a>
          ”进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。</p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。达领生物有适用于不同研究物种的高质量提取试剂盒，您可以根据自己的研究对象来进行选择【
            <a href=${this.linkList["tqUrl"]}  target='_Blank' data-type="${this.linkList["tqUrl"]}">提取</a>
          】</p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，可能是您当前使用的PCR酶扩增效率偏低。由于PCR酶对于DNA具有一定的偏好性，可通过优化PCR程序如：增加循环数、降低退火温度、适当提高Mg2+工作浓度来提高扩增效率，然而当您使的酶经过优化难以获得理想扩增时，推荐您使用耐脏性好，扩增效率高的PCR酶，如擎科生物的
            <a href=${this.linkList["jpmixUrl"]}  target='_Blank' data-type="${this.linkList["jpmixUrl"]}">金牌 Mix (green)</a>
          （货号：TSE101）</p>
        </div>`;
      this.solutionStripless10 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为无条带、无主带或引物二聚体。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或有杂质，建议您先对模板DNA进行质量检测，推荐您使用
            <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">“核酸电泳全家桶”</a>
            进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。
          </p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。达领生物有适用于不同研究物种的高质量提取试剂盒，您可以根据自己的研究对象来进行选择【
            <a href=${this.linkList["tqUrl"]}  target='_Blank' data-type="${this.linkList["tqUrl"]}">提取</a>
            】
          </p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，可能是您当前使用的引物不合适，建议重新设计引物，请点击
            <a href=${this.linkList["sjywUrl"]}  target='_Blank' data-type="${this.linkList["sjywUrl"]}">设计引物</a>
            进行设计，您也可以参加
            <a href=${this.linkList["pcrywsjjntskUrl"]}  target='_Blank' data-type="${this.linkList["pcrywsjjntskUrl"]}">PCR引物设计技能提升课</a>
            ，学习引物设计原理与方法，自行设计并合成引物。
          </p>
        </div>`;
      this.solutionLowConcentration10 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为无条带、无主带或引物二聚体。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或有杂质，建议您先对模板DNA进行质量检测，推荐您使用
            <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">核酸电泳全家桶</a>
            进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。
          </p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。达领生物有适用于不同研究物种的高质量提取试剂盒，您可以根据自己的研究对象来进行选择【
            <a href=${this.linkList["tqUrl"]}  target='_Blank' data-type="${this.linkList["tqUrl"]}">提取</a>
            】
          </p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，可能是您当前使用的PCR酶扩增效率偏低。由于PCR酶对于DNA具有一定的偏好性，可通过优化PCR程序如：增加循环数、降低退火温度、适当提高Mg2+工作浓度来提高扩增效率，然而当您使的酶经过优化难以获得理想扩增时，推荐您使用耐脏性好，扩增效率高的PCR酶，如擎科生物的
            <a href=${this.linkList["jpmixUrl"]}  target='_Blank' data-type="${this.linkList["jpmixUrl"]}">金牌 Mix (green)</a>
            （货号：TSE101）
          </p>
        </div>`;
      this.linewConcentration10 = `<div class="content-solution">
          <p>我们对您提供的样品进行了的琼脂糖凝胶电泳检测，鉴定结果为浓度低。经过我们专业团队判断，出现该现象的原因可能是模板DNA浓度低或有杂质，建议您先对模板DNA进行质量检测，推荐您使用“
           <a href=${this.linkList["hsdyqjtUrl"]}  target='_Blank' data-type="${this.linkList["hsdyqjtUrl"]}">核酸电泳全家桶</a>
          ”进行琼脂进行琼脂糖凝胶电泳检测。根据检测结果，我们提供以下两种解决方案，来辅助您快速完成实验。  
          </p>
          <p>方案1：模板降解。如果检查结果出现条带弥散或者条带亮度较暗，说明模板发生了降解，建议您重新制备高质量的模板。达领生物有适用于不同研究物种的高质量提取试剂盒，您可以根据自己的研究对象来进行选择【
            <a href=${this.linkList["tqUrl"]}  target='_Blank' data-type="${this.linkList["tqUrl"]}">提取</a>】
          </p>
          <p>方案2：模板正常。如果琼脂糖凝胶电泳检测模板质量较好，可能是您当前使用的PCR酶扩增效率偏低。由于PCR酶对于DNA具有一定的偏好性，可通过优化PCR程序如：增加循环数、降低退火温度、适当提高Mg2+工作浓度来提高扩增效率，然而当您使的酶经过优化难以获得理想扩增时，  推荐您使用耐脏性好，扩增效率高的PCR酶 如擎科生物的
          <a href=${this.linkList["jpmixUrl"]}  target='_Blank' data-type="${this.linkList["jpmixUrl"]}">金牌 Mix (green)</a>
          （货号：TSE101）
          </p>
        </div>`;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-table th {
    font-weight: bold;
    color: #333;
    text-align: center;
    background: #F6FAFD !important;
}
/deep/ .el-table td {
    text-align: center;
}
.contain-email-link {
  width: 100%;
  padding: 10px 300px;
  /deep/ .content-solution {
    text-align: left;
    p {
      text-indent: 4ch;
      line-height: 30px;
      padding: 10px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/EmailLink/index.vue